$(document).ready(function(){
  if(($('.application-form').length > 0 && $('.application-form').data('lang') == 'no') || ($('.candidate-proposal-form').length > 0 && $('.candidate-proposal-form').data('lang') == 'no') || ($('.hearing-response-form').length > 0 && $('.hearing-response-form').data('lang') == 'no')) {
      $('.codedropz-upload-inner span').html('eller');
      $('.codedropz-upload-inner span').first().html('Dra og slipp filer her');
      $('.codedropz-upload-inner .cd-upload-btn').html('Bla gjennom filer');
  }
});